<script>
import Vue from "vue";
import store from "/src/store.js";

export default {
  hasPermission(action, name) {

    var permission = store.getters.PermissionList.find(
      x => x.Action == action && x.Name == name
    );

    if (permission == null) {
      return false;
    } else {
      return true;
    }
  }
};
</script>